
import Vue from 'vue';

export default Vue.extend({
	name: 'TrainingVideoPlayer',
	props: {
		videoUrl: {
			type: String,
			required: true,
		},
	},
	computed: {
		isYouTubeUrl (): boolean {
			if (!this.videoUrl) return false;
			const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
			return youtubeRegex.test(this.videoUrl);
		},

		youTubeVideoId (): string | null {
			if (!this.isYouTubeUrl) return null;
			const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
			const match = this.videoUrl.match(youtubeRegex);
			return match ? match[1] : null;
		},

		youTubeEmbedUrl (): string {
			if (!this.youTubeVideoId) return '';
			return `https://www.youtube.com/embed/${this.youTubeVideoId}`;
		},

		isDirectVideoUrl (): boolean {
			if (!this.videoUrl || this.isYouTubeUrl) return false;
			const videoExtensions = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)(\?.*)?$/i;
			return videoExtensions.test(this.videoUrl) || this.videoUrl.includes('.mp4') || this.videoUrl.includes('.webm');
		},
	},
	methods: {
		handleVideoError (event: Event): void {
			console.error('Error loading video:', event);
			this.$emit('video-error', event);
		},
	},
});
